import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import PiConnectionTableDto from '../dto/PiConnectionTableDto';

class PiConnectionTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'piConnectionTableControl';
	}

	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, { session, firstResult, maxResults })
				.then(response => resolve(new GenericTableDto().setup(response.data, PiConnectionTableDto)))
				.catch(reject);
		});
	}
}

export default new PiConnectionTableService();
